import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {useTable} from "react-table";
import Select, {createFilter} from "react-select";
import {MonthData, OverRidesSelect, WeekData} from "./SelectData";
import ConsoleHelper from "../ConsoleHelper";
import {useHistory, useLocation} from "react-router-dom";
import axios from "axios";
import {
    getAccountManagerScheduleOverrideInfoByLoggedUserApi,
    getAccountManagerScheduleOverrideInfoByTerminalIDApi,
    removeAccountManagerScheduleOverrideInfoByTerminalIDApi,
    saveAccountManagerScheduleOverrideApi,
    TerminalDataTableListMgmtApi
} from "../Api";
import {terminalListContext} from "../App";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import DataTable from "react-data-table-component";

function AccountManagerOverRide() {
  const defaultSelectOption = { label: "Daily", value: 0 };
    const defaultSelectDayOption = { label: "Daily", value: 0 };
  const [data, setData] = useState([]);
    const {terminalList:terminalOptions, setTerminalList:setTerminalOptions}  = useContext(terminalListContext);
    const [terminalOverrideData, setTerminalOverrideData] = useState([]);
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [selectedTerminal, setSelectedTerminal] = useState([]);
    const [selectedOption, setSelectedOption] = useState("1");
    const [selectedSurchargeOption, setSelectedSurchargeOption] = useState("1");
    const [selectedInterchangeOption, setSelectedInterchageOption] = useState("1");
    const [updatePage, setUpdatePage] = useState(false);
    const [bankAddress, setBankAddress] = useState();
    const [paramSourceType, setParamSourceType] = useState("2");
    const [paramSurchargeThresholdAmount, setParamSurchargeThresholdAmount] = useState(0);
    const [paramSettlementThresholdAmount, setParamSettlementThresholdAmount] = useState(0);
    const [paramInterchangeThresholdAmount, setParamInterchangeThresholdAmount] = useState(0);
    const [paramBankCountry, setParamBankCountry] = useState();
    const [paramBankRegion, setParamBankRegion] = useState();
  const [settlementSelect, setSettlementSelect] = useState(defaultSelectOption);
  const [surchargeSelect, setSurchargeSelect] = useState(defaultSelectOption);
  const [InterchangeSelect, setInterchangeSelect] = useState(defaultSelectOption);
  const [settlementEndDay, setSettlementEndDay] = useState(0);
  const [settlementPayoutDay, setSettlementPayoutDay] = useState(0);
  const settlementThreshold = useRef();
  const [surchargeEndDay, setSurchargeEndDay] = useState();
  const [surchargePayoutDay, setSurchargePayoutDay] = useState();
  const surchargeThreshold = useRef();
  const [interChangeEndDay, setInterChangeEndDay] = useState();
  const [interChangePayoutDay, setInterChangePayoutDay] = useState();
  const interChangeThreshold = useRef();
    const [rtaNumber, setRtaNumber] = useState();
    const [resetUserForm, setResetUserForm] = useState(false);
    const [paramAccountID, setParamAccountID] = useState();
  const [isFormVisible, setIsFormVisible] = useState(false);
    const [pending, setPending] = useState(true);
    const history = useHistory();
    const location = useLocation();

    const tableStyles = {
        rows: {
            style: {
                minHeight: '40px', // override the row height

            },
        },
        headCells: {
            style: {
                paddingLeft: '2px', // override the cell padding for head cells
                paddingRight: '2px',
            },
        },
        cells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
                fontsize: 'inherit',
            },
        },
    };
    /**Custom table code*/


    const handleTerminalTableRowClick = (terminalId) => {
        getOverrideTerminalData(terminalId);
    };

    const getOverrideTerminalData = async (terminalId) => {
        setIsFormVisible(false);
        const result = await axios.get(`${getAccountManagerScheduleOverrideInfoByTerminalIDApi}?paramAccountID=${paramAccountID}&paramTerminalID=${terminalId}`,{
            mode: 'no-cors' // 'cors' by default
        });
        let settlementTypeLabel;let surchargeTypeLabel;let interchangeTypeLabel;let weeklyLabelPayoutDay;let weeklyLabelDay;
        //console.log(result?.data.response?.[0], "results for terminalID override info");
        setUpdatePage(false);
        setIsFormVisible(true);
        setTerminalOverrideData(result.data);
        setSelectedTerminal({
            label: result?.data.response?.[0]?.sourceCode,
            value: result?.data.response?.[0]?.sourceCode,
        });
        //settlement
        settlementTypeLabel = result?.data.response?.[0]?.settlementScheduleType=== 0 ? "Daily":
            (result?.data.response?.[0]?.settlementScheduleType=== 1 ? "Weekly":
                (result?.data.response?.[0]?.settlementScheduleType === 3 ? "Monthly":
                    (result?.data.response?.[0]?.settlementScheduleType === 5 ? "Threshold":"")));

        weeklyLabelDay = result?.data.response?.[0]?.settlementScheduleDay=== 1 ? "Monday":
            (result?.data.response?.[0]?.settlementScheduleDay=== 2 ? "Tuesday":
                (result?.data.response?.[0]?.settlementScheduleDay === 3 ? "Wednesday":
                    (result?.data.response?.[0]?.settlementScheduleDay === 4 ? "Thursday":
                        (result?.data.response?.[0]?.settlementScheduleDay === 5 ? "Friday":
                            (result?.data.response?.[0]?.settlementScheduleDay === 6 ? "Saturday":
                                (result?.data.response?.[0]?.settlementScheduleDay === 7 ? "Sunday":""))))));

        weeklyLabelPayoutDay = result?.data.response?.[0]?.settlementSchedulePayoutDay=== 1 ? "Monday":
            (result?.data.response?.[0]?.settlementSchedulePayoutDay=== 2 ? "Tuesday":
                (result?.data.response?.[0]?.settlementSchedulePayoutDay === 3 ? "Wednesday":
                    (result?.data.response?.[0]?.settlementSchedulePayoutDay === 4 ? "Thursday":
                        (result?.data.response?.[0]?.settlementSchedulePayoutDay === 5 ? "Friday":
                            (result?.data.response?.[0]?.settlementSchedulePayoutDay === 6 ? "Saturday":
                                (result?.data.response?.[0]?.settlementSchedulePayoutDay === 7 ? "Sunday":""))))));

        setSettlementSelect({
            label: settlementTypeLabel,
            value: result?.data.response?.[0]?.settlementScheduleType,
        })
        setSettlementEndDay({
            label: weeklyLabelDay,
            value: result?.data.response?.[0]?.settlementScheduleDay,
        })
        setSettlementPayoutDay({
            label: weeklyLabelPayoutDay,
            value: result?.data.response?.[0]?.settlementSchedulePayoutDay,
        })

        //surcharge
        surchargeTypeLabel = result?.data.response?.[0]?.surchargeScheduleType=== 0 ? "Daily":
            (result?.data.response?.[0]?.surchargeScheduleType=== 1 ? "Weekly":
                (result?.data.response?.[0]?.surchargeScheduleType === 3 ? "Monthly":
                    (result?.data.response?.[0]?.surchargeScheduleType === 5 ? "Threshold":"")));

        weeklyLabelDay = result?.data.response?.[0]?.surchargeScheduleDay=== 1 ? "Monday":
            (result?.data.response?.[0]?.surchargeScheduleDay=== 2 ? "Tuesday":
                (result?.data.response?.[0]?.surchargeScheduleDay === 3 ? "Wednesday":
                    (result?.data.response?.[0]?.surchargeScheduleDay === 4 ? "Thursday":
                        (result?.data.response?.[0]?.surchargeScheduleDay === 5 ? "Friday":
                            (result?.data.response?.[0]?.surchargeScheduleDay === 6 ? "Saturday":
                                (result?.data.response?.[0]?.surchargeScheduleDay === 7 ? "Sunday":""))))));

        weeklyLabelPayoutDay = result?.data.response?.[0]?.surchargeSchedulePayoutDay=== 1 ? "Monday":
            (result?.data.response?.[0]?.surchargeSchedulePayoutDay=== 2 ? "Tuesday":
                (result?.data.response?.[0]?.surchargeSchedulePayoutDay === 3 ? "Wednesday":
                    (result?.data.response?.[0]?.surchargeSchedulePayoutDay === 4 ? "Thursday":
                        (result?.data.response?.[0]?.surchargeSchedulePayoutDay === 5 ? "Friday":
                            (result?.data.response?.[0]?.surchargeSchedulePayoutDay === 6 ? "Saturday":
                                (result?.data.response?.[0]?.surchargeSchedulePayoutDay === 7 ? "Sunday":""))))));

        setSurchargeSelect({
            label: surchargeTypeLabel,
            value: result?.data.response?.[0]?.surchargeScheduleType,
        })
        setSurchargeEndDay({
            label: weeklyLabelDay,
            value: result?.data.response?.[0]?.surchargeScheduleDay,
        })
        setSurchargePayoutDay({
            label: weeklyLabelPayoutDay,
            value: result?.data.response?.[0]?.surchargeSchedulePayoutDay,
        })

        //interchange d

        interchangeTypeLabel = result?.data.response?.[0]?.interchangeScheduleType=== 0 ? "Daily":
            (result?.data.response?.[0]?.interchangeScheduleType=== 1 ? "Weekly":
                (result?.data.response?.[0]?.interchangeScheduleType === 3 ? "Monthly":
                    (result?.data.response?.[0]?.interchangeScheduleType === 5 ? "Threshold":"")));

        weeklyLabelDay = result?.data.response?.[0]?.interchangeScheduleDay=== 1 ? "Monday":
            (result?.data.response?.[0]?.interchangeScheduleDay=== 2 ? "Tuesday":
                (result?.data.response?.[0]?.interchangeScheduleDay === 3 ? "Wednesday":
                    (result?.data.response?.[0]?.interchangeScheduleDay === 4 ? "Thursday":
                        (result?.data.response?.[0]?.interchangeScheduleDay === 5 ? "Friday":
                            (result?.data.response?.[0]?.interchangeScheduleDay === 6 ? "Saturday":
                                (result?.data.response?.[0]?.interchangeScheduleDay === 7 ? "Sunday":""))))));

        weeklyLabelPayoutDay = result?.data.response?.[0]?.surchargeSchedulePayoutDay=== 1 ? "Monday":
            (result?.data.response?.[0]?.interchangeSchedulePayoutDay=== 2 ? "Tuesday":
                (result?.data.response?.[0]?.interchangeSchedulePayoutDay === 3 ? "Wednesday":
                    (result?.data.response?.[0]?.interchangeSchedulePayoutDay === 4 ? "Thursday":
                        (result?.data.response?.[0]?.interchangeSchedulePayoutDay === 5 ? "Friday":
                            (result?.data.response?.[0]?.interchangeSchedulePayoutDay === 6 ? "Saturday":
                                (result?.data.response?.[0]?.interchangeSchedulePayoutDay === 7 ? "Sunday":""))))));

        setInterchangeSelect({
            label: interchangeTypeLabel,
            value: result?.data.response?.[0]?.interchangeScheduleType,
        })
        setInterChangeEndDay({
            label: weeklyLabelDay,
            value: result?.data.response?.[0]?.interchangeScheduleDay,
        })
        setInterChangePayoutDay({
            label: weeklyLabelPayoutDay,
            value: result?.data.response?.[0]?.interchangeSchedulePayoutDay,
        })
        interChangeThreshold.current = result?.data.response?.[0]?.interchangeThresholdAmount;
        setParamInterchangeThresholdAmount(result?.data.response?.[0]?.interchangeThresholdAmount);

        ConsoleHelper((paramInterchangeThresholdAmount));
    };

    const menu = {
        glyph1: (<span class="icon">&#xe80d;</span>)
    };

    const datacolumns = [
        {
            name: 'Object Type',
            selector: row => 'Terminal',
            sortable: true,
            center: true,
        },
        {
            name: 'Designation ',
            selector: row => (
                <h2
                    style={{
                        color: "blue",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "normal",
                        fontSize: "inherit",
                    }}
                    onClick={() => handleTerminalTableRowClick(row.sourceCode)}
                >
                    {row.sourceCode}
                </h2>
            ),
            sortable: true,

        },
        {
            name: 'Action',
            font: '10px',
            selector: row => (
                <span
                    class="input-group-text"
                    role="button"
                    style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "normal",
                        height: "25px"

                    }}
                    onClick={() => handleTerminalRemoveRowClick(row)}
                >
                    Remove
                </span>


            )
        }
    ];

  const FormSelect = (props) => {
    return (
      <div class="form-group form-inline">
        <label htmlFor="exampleInputEmail1">{props.label}</label>
        <div class="input-group ml-2">
          {!props.input ? (
            <Select
              options={props.options}
              onChange={props.onChange}
              defaultValue={props.defaultValue}
              value={props.value}
              styles={{
                container: (provided) => ({
                  ...provided,
                  flex: 1,
                  width: "13vw",
                }),
              }}
            />
          ) : (
            <input
              defaultValue={props.defaultValue}
              onChange={props.onChange}
              value={props.value}
            />
          )}
        </div>
      </div>
    );
  };

  const handleSettlementSelectChange = (e) => {
    setSettlementEndDay();
    setSettlementPayoutDay();
    setSettlementSelect(e);
  };
  const handleInterChangeSelectChange = (e) => {
    setInterChangeEndDay();
    setInterChangePayoutDay();
    setInterchangeSelect(e);
  };
  const handleSurchargeSelectChange = (e) => {
    setSurchargeEndDay();
    setSurchargePayoutDay();
    setSurchargeSelect(e);
  };

    useEffect(() => {
        ConsoleHelper("Called on Page Load......");
        ConsoleHelper("history hold",history.location.state?.from?.split("?")[1]);
        //setRta and account number
        let rtaFromLoc = (history.location.state?.from?.split("?")[1].split("=")?.[1]?.split("&")?.[0])?.replace(/[^\w @]/g, '');
        let paramAccountIDLoc = history.location.state?.from?.split("?")[1].split("=")?.[2]?.replace(/[^\w @]/g, '');
        console.log(rtaFromLoc," ---- ",paramAccountIDLoc)
        //setRta and account number
        setRtaNumber(rtaFromLoc);
        setParamAccountID(paramAccountIDLoc);

        history.push({
            pathname: "/accountManager/override",
            search: `rta=${rtaFromLoc}&AccountID=${paramAccountIDLoc}`,
        });
        getProduct();
        setPending(false);
        return () => {
            setParamBankCountry("18");
            setParamBankRegion("USA");
            setSettlementSelect({ label: "Daily", value: 0 });
            setSettlementEndDay({ label: "0", value: 0 });
            setSettlementPayoutDay({ label: "0", value: 0 });
            setSurchargeSelect({ label: "Daily", value: 0 });
            setSurchargeEndDay({ label: "0", value: 0 });
            setSurchargePayoutDay({ label: "0", value: 0 });
            setInterchangeSelect({ label: "Daily", value: 0 });
            setInterChangeEndDay({ label: "0", value: 0 });
            setInterChangePayoutDay({ label: "0", value: 0 });

        };
    }, [resetUserForm,updatePage]);


    const getProduct = useCallback(() => {
        const fetchResults = async () => {
            let resultTerminal = await axios.get(`${TerminalDataTableListMgmtApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
                mode: 'no-cors' // 'cors' by default
            });
            //console.log("END OF TERMINAL RETRIEVE");
            //let resultOverrideDetails = await axios.get(`${getAccountManagerScheduleOverrideInfoByLoggedUserApi}?paramAccountID=${paramAccountID}`,{
            let resultOverrideDetails = await axios.get(`${getAccountManagerScheduleOverrideInfoByLoggedUserApi}?paramAccountID=11411`,{
                mode: 'no-cors' // 'cors' by default
            });

            //console.log("END OF OVERRIDE RETRIEVE");
            setTerminalOptions(resultTerminal?.data?.response);
            setSelectedTerminal({
                label: resultTerminal?.data.response?.[0]?.terminalID,
                value: resultTerminal?.data.response?.[0]?.terminalID,
            });
            ConsoleHelper(resultOverrideDetails?.data?.response)
            setData(resultOverrideDetails?.data?.response);

        };
        fetchResults();
    }, [updatePage]);

    const handleTerminalRemoveRowClick = (data) => {
        data["paramAccountID"] = paramAccountID;
        data["paramTerminalID"] = data.sourceCode;

        axios.post(
            `${removeAccountManagerScheduleOverrideInfoByTerminalIDApi}`,data
        )
            .then(res => {
                //ConsoleHelper(" after saving override "+res)
                alert("Terminal removed Successfully!!")
            }).catch(error => {
            console.log("Exception Thrown::save Override values",error);
        });
        getProduct();
        setUpdatePage(true);

    };


  const handleFormSubmit = () => {
    const data = {};
      data["paramAccountID"] = paramAccountID;
      data["paramSourceType"] = paramSourceType;
      data["paramSourceCode"] = selectedTerminal.terminalID;
      //logic to check if terminal id is not selected then pick from default
      if (typeof selectedTerminal.terminalID === 'undefined') {
          data["paramSourceCode"] = selectedTerminal.value;
      }
      //Settlement

      data["paramSettlementThresholdAmount"] = paramSettlementThresholdAmount;
      data["paramSettlementScheduleType"]=settlementSelect.value;
      data["paramSettlementScheduleDay"] = defaultSelectDayOption.value;
      data["paramSettlementSchedulePayoutDay"] = defaultSelectDayOption.value;
      ConsoleHelper(defaultSelectOption.value)
    if (settlementSelect.value === 5) {
      data["paramSettlementThresholdAmount"] = settlementThreshold?.current;
    } else {
        if(settlementSelect?.value != 0 && (typeof settlementEndDay?.value== "undefined" || typeof settlementPayoutDay?.value== "undefined")){
            alert(" Please select Settlement EndDay and PayoutDay");
            return false;
        }
      data["paramSettlementScheduleDay"] = typeof settlementEndDay?.value== "undefined" ? defaultSelectDayOption.value:settlementEndDay?.value;
      data["paramSettlementSchedulePayoutDay"] = typeof settlementPayoutDay?.value== "undefined" ? defaultSelectDayOption.value:settlementPayoutDay?.value;
    }

    //surcharge
      data["paramSurchargeThresholdAmount"] = paramSurchargeThresholdAmount;
      data["paramSurchargeScheduleType"]=surchargeSelect.value;
      data["paramSurchargeScheduleDay"] = defaultSelectDayOption.value;;
      data["paramSurchargeSchedulePayoutDay"] = defaultSelectDayOption.value;;

    if (surchargeSelect.value === 5) {
      data["paramSurchargeThresholdAmount"] = surchargeThreshold.current;
    } else {
        if(surchargeSelect?.value != 0 && (typeof surchargeEndDay?.value== "undefined" || typeof surchargePayoutDay?.value== "undefined")){
            alert(" Please select Surcharge EndDay and PayoutDay");
            return false;
        }
      data["paramSurchargeScheduleDay"] = typeof surchargeEndDay?.value== "undefined" ? defaultSelectDayOption.value:surchargeEndDay?.value;
      data["paramSurchargeSchedulePayoutDay"] = typeof surchargePayoutDay?.value== "undefined" ? defaultSelectDayOption.value:surchargePayoutDay?.value;
    }

    //interchange data
      data["paramInterchangeThresholdAmount"] = paramInterchangeThresholdAmount;
      data["paramInterchangeScheduleType"]=InterchangeSelect.value;
      data["paramInterchangeScheduleDay"] = defaultSelectDayOption.value;;
      data["paramInterchangeSchedulePayoutDay"] = defaultSelectDayOption.value;;
    if (InterchangeSelect.value === 5) {
      data["paramInterchangeThresholdAmount"] = interChangeThreshold?.current;
    } else {
        if(InterchangeSelect?.value != 0 && (typeof interChangeEndDay?.value== "undefined" || typeof interChangePayoutDay?.value== "undefined")){
            alert(" Please select Interchange EndDay and PayoutDay");
            return false;
        }
      data["paramInterchangeScheduleDay"] = typeof interChangeEndDay?.value== "undefined" ? defaultSelectDayOption.value:interChangeEndDay?.value;
      data["paramInterchangeSchedulePayoutDay"] = typeof interChangePayoutDay?.value== "undefined" ? defaultSelectDayOption.value:interChangePayoutDay?.value;
    }
    //console.log(data);
    // here call the api for saving the data and update the table data
     /* ConsoleHelper(" bankName ",bankName)
      ConsoleHelper(" bankAddress ",bankAddress)

      ConsoleHelper("paramSettlementType ",settlementSelect);
      ConsoleHelper("paramSettlementScheduleDay ",settlementEndDay);
      ConsoleHelper("paramSettlementSchedulePayoutDay ",settlementPayoutDay);
      ConsoleHelper("paramSettlementThresholdAmount ",settlementThreshold);

      ConsoleHelper("param surcharge type ",surchargeSelect);
      ConsoleHelper("paramSurchargeDay ",surchargeEndDay);
      ConsoleHelper("paramSurchargePayoutDay ",surchargePayoutDay);
      ConsoleHelper("paramSurchrageThresholdAmount ",surchargeThreshold);

      ConsoleHelper("param interchange",InterchangeSelect);
      ConsoleHelper("paraminterchangeDay ",interChangeEndDay);
      ConsoleHelper("paraminterchangePayoutDay ",interChangePayoutDay);
      ConsoleHelper("paraminterchangeThresholdAmount ",interChangeThreshold);*/
    //  after the result false the setIsFormVisible
      axios.post(
          `${saveAccountManagerScheduleOverrideApi}`,data
      )
          .then(res => {
              //ConsoleHelper(" after saving override "+res)
          }).catch(error => {
          console.log("Exception Thrown::save Override values",error);
      });
      setIsFormVisible(false);
      setResetUserForm(true);
      getProduct();
      setUpdatePage(true);
  };
  return (
    <div className="row mt-3">
      <div className={`col col-md-${isFormVisible ? 4 : 6}`}>
        {
          <>
              <span
                  className="d-block p-2 text-white mb-6"
                  style={{background: "#002170"}}
              >
                Account Override List
              </span>
                  <DataTable
                      columns={datacolumns}
                      data={data}
                      noHeader
                      dense
                      highlightOnHover
                      progressPending={pending}
                      pointerOnHover
                      customStyles={tableStyles}
                  />
            <div className="mt-3 d-flex justify-content-center">
              <span
                class="input-group-text"
                role="button"
                onClick={() => {
                  setIsFormVisible(true);
                }}
              >
                Add
              </span>
            </div>
          </>
        }
      </div>
      {isFormVisible ? (
        <div className="col col-md-8 border">
          {/* 1 */}
          <div className="row">
            <div className="col col-md-12">
              <span
                class="d-block p-2 text-white mb-3"
                style={{ background: "#002170" }}
              >
                Schedule OverRide Viewer / Editor
              </span>
            </div>
            <div className="col col-md-6">Object Type</div>
            <div className="col col-md-6">Terminal</div>
            <div className="col col-md-6">Designation</div>

            <div className="col col-md-6">
                <Select
                    options={terminalOptions}
                    filterOption={createFilter({ ignoreAccents: false })}
                    captureMenuScroll={false}
                    classNamePrefix="custom-select"
                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                    onChange={(e) => setSelectedTerminal(e)}
                    value={selectedTerminal}
                    styles={{
                        container: (provided) => ({
                            ...provided,
                            flex: 1,
                            fontSize: 'inherit',
                        }),
                    }}
                />
            </div>
          </div>
          {/* 2 */}
          <div className="row mt-3">
            <div className="col col-md-12">
              <span
                class="d-block p-2 text-white mb-3"
                style={{ background: "#002170" }}
              >
                Settlement
              </span>
            </div>
            <div className="col col-md-6">Schedule Type:</div>
            <div className="col col-md-6">
              <Select
                options={OverRidesSelect}
                value={settlementSelect}
                onChange={handleSettlementSelectChange}
              />
            </div>
            {(settlementSelect?.value === "1"  || settlementSelect?.value === 1) && (
              <>
                <div className="col col-md-12">
                  <FormSelect
                    label="End Day:"
                    options={WeekData}
                    defaultValue={settlementEndDay}
                    onChange={(e) => {
                      setSettlementEndDay(e);
                    }}
                  />
                </div>
                <div className="col col-md-12">
                  <FormSelect
                    label="Payout Day:"
                    options={WeekData}
                    defaultValue={settlementPayoutDay}
                    onChange={(e) => {
                      setSettlementPayoutDay(e);
                    }}
                  />
                </div>
              </>
            )}
            {(settlementSelect?.value === "3" || settlementSelect?.value === 3) && (
              <>
                <div className="col col-md-12">
                  <FormSelect
                    label="End Day:"
                    options={MonthData}
                    defaultValue={settlementEndDay}
                    onChange={(e) => {
                      setSettlementEndDay(e);
                    }}
                  />
                </div>
                <div className="col col-md-12">
                  <FormSelect
                    label="Payout Day:"
                    options={MonthData}
                    defaultValue={settlementPayoutDay}
                    onChange={(e) => {
                      setSettlementPayoutDay(e);
                    }}
                  />
                </div>
              </>
            )}

            {(settlementSelect?.value === "5" || settlementSelect?.value === 5) && (
              <div className="col col-md-12">
                <FormSelect
                  label="Threshold Amount:"
                  input
                  defaultValue={settlementThreshold.current}
                  onChange={(e) =>
                    (settlementThreshold.current = e.target.value)
                  }
                />
              </div>
            )}
          </div>
          {/* 3 */}
          <div className="row mt-3">
            <div className="col col-md-12">
              <span
                class="d-block p-2 text-white mb-3"
                style={{ background: "#002170" }}
              >
                Surcharge
              </span>
            </div>
            <div className="col col-md-6">Surcharge Type:</div>
            <div className="col col-md-6">
              <Select
                options={OverRidesSelect}
                value={surchargeSelect}
                onChange={handleSurchargeSelectChange}
              />
            </div>
            {(surchargeSelect?.value === "1" || surchargeSelect?.value === 1) && (
              <>
                <div className="col col-md-12">
                  <FormSelect
                    label="End Day:"
                    options={WeekData}
                    defaultValue={surchargeEndDay}
                    onChange={(e) => {
                      setSurchargeEndDay(e);
                    }}
                  />
                </div>
                <div className="col col-md-12">
                  <FormSelect
                    label="Payout Day:"
                    options={WeekData}
                    defaultValue={surchargePayoutDay}
                    onChange={(e) => {
                      setSurchargePayoutDay(e);
                    }}
                  />
                </div>
              </>
            )}
            {(surchargeSelect?.value === "3" || surchargeSelect?.value === 3) && (
              <>
                <div className="col col-md-12">
                  <FormSelect
                    label="End Day:"
                    options={MonthData}
                    defaultValue={surchargeEndDay}
                    onChange={(e) => {
                      setSurchargeEndDay(e);
                    }}
                  />
                </div>
                <div className="col col-md-12">
                  <FormSelect
                    label="Payout Day:"
                    options={MonthData}
                    defaultValue={surchargePayoutDay}
                    onChange={(e) => {
                      setSurchargePayoutDay(e);
                    }}
                  />
                </div>
              </>
            )}
            {(surchargeSelect?.value === "5" || surchargeSelect?.value === 5)&& (
              <div className="col col-md-12">
                <FormSelect
                  label="Threshold Amount:"
                  input
                  defaultValue={surchargeThreshold.current}
                  onChange={(e) => {
                    surchargeThreshold.current = e.target.value;
                  }}
                />
              </div>
            )}
          </div>
          {/* 4 */}
          <div className="row mt-3">
            <div className="col col-md-12">
              <span
                class="d-block p-2 text-white mb-3"
                style={{ background: "#002170" }}
              >
                Interchange
              </span>
            </div>
            <div className="col col-md-6">Interchange Type:</div>
            <div className="col col-md-6">
              <Select
                options={OverRidesSelect}
                value={InterchangeSelect}
                onChange={handleInterChangeSelectChange}
              />
            </div>
            {(InterchangeSelect?.value === "1" || InterchangeSelect?.value === 1) && (
              <>
                <div className="col col-md-12">
                  <FormSelect
                    label="End Day:"
                    options={WeekData}
                    defaultValue={interChangeEndDay}
                    onChange={(e) => {
                      setInterChangeEndDay(e);
                    }}
                  />
                </div>
                <div className="col col-md-12">
                  <FormSelect
                    label="Payout Day:"
                    options={WeekData}
                    defaultValue={interChangePayoutDay}
                    onChange={(e) => {
                      setInterChangePayoutDay(e);
                    }}
                  />
                </div>
              </>
            )}
            {(InterchangeSelect?.value === 3)&& (
              <>
                <div className="col col-md-12">
                  <FormSelect
                    label="End Day:"
                    options={MonthData}
                    defaultValue={interChangeEndDay}
                    onChange={(e) => {
                      setInterChangeEndDay(e);
                    }}
                  />
                </div>
                <div className="col col-md-12">
                  <FormSelect
                    label="Payout Day:"
                    options={MonthData}
                    defaultValue={interChangePayoutDay}
                    onChange={(e) => {
                      setInterChangePayoutDay(e);
                    }}
                  />
                </div>
              </>
            )}

            {(InterchangeSelect?.value === 5)&& (
              <div className="col col-md-12">
                <FormSelect
                  label="Threshold Amount:"
                  input
                  defaultValue={interChangeThreshold.current}
                  onChange={(e) => {
                    interChangeThreshold.current = e.target.value;
                  }}
                />
              </div>
            )}
          </div>
          {/*  */}
          <div
            className="mt-3 d-flex justify-content-center mb-3 mt-3"
            style={{ gap: "20px" }}
          >
            <span
              class="input-group-text"
              role="button"
              onClick={handleFormSubmit}
            >
              Save
            </span>
            <span
              class="input-group-text"
              role="button"
              onClick={() => {
                setIsFormVisible(false);
              }}
            >
              Cancel
            </span>
          </div>
          {/*  */}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default AccountManagerOverRide;
